import React, {Component} from 'react'
import classnames from 'classnames'

import {
  FlexBox,
  FlexDirection,
  JustifyContent,
  ButtonType,
  AlignItems,
} from '@influxdata/clockface'

import AWSLogo from './AWSLogo'
import GCPLogo from './GCPLogo'
import AzureLogo from './AzureLogo'

import {ProviderInfo, Provider} from 'js/types'

interface Props extends ProviderInfo {
  onClick: (provider: Provider) => void
  isSelected: boolean
}

class ProviderOption extends Component<Props> {
  render() {
    const {provider, title, isSelected, isAvailable} = this.props

    const className = classnames('provider--item', {selected: isSelected})

    return (
      <button
        key={provider}
        className={className}
        type={ButtonType.Button}
        title={this.buttonTitle}
        onClick={this.handleClick}
        disabled={!isAvailable}
      >
        <div className="provider--item-title">
          <p>{title}</p>
        </div>
        <FlexBox
          direction={FlexDirection.Column}
          justifyContent={JustifyContent.Center}
          alignItems={AlignItems.Center}
          className="provider--item-body"
        >
          {this.logo}
          {this.comingSoonText}
        </FlexBox>
      </button>
    )
  }

  private get logo(): JSX.Element {
    switch (this.props.provider) {
      case Provider.AWS:
        return <AWSLogo />
      case Provider.GCP:
        return <GCPLogo />
      case Provider.Azure:
        return <AzureLogo />
    }
  }

  private get buttonTitle(): string {
    const {title, isAvailable} = this.props

    if (!isAvailable) {
      return `${title} is coming soon`
    }

    return `Select ${title} as Cloud Provider`
  }

  private get comingSoonText(): JSX.Element {
    const {isAvailable} = this.props

    if (!isAvailable) {
      return <p className="coming-soon">COMING SOON</p>
    }
  }

  private handleClick = (): void => {
    const {onClick, provider} = this.props

    onClick(provider)
  }
}

export default ProviderOption
